
import localforage from 'localforage';
import {
  AUTH_ROUTES_CONFIG,
} from '@/consts';

/**
 * slice array elements into groups, each group's max length equal to sum
 * @param  {Array} arr
 * @param  {Number} sum
 * @returns {Array}
 */
export function groupBySum(arr, sum = 1) {
  if (sum <= 0) {
    return arr;
  }

  return arr.reduce((acc, elem, index) => {
    const remain = index % sum;

    if (remain === 0) {
      return [...acc, [elem]];
    }

    const groupIndex = acc.length - 1;
    const currGroup = acc[groupIndex];
    acc[groupIndex] = [...currGroup, elem];

    return acc;
  }, []);
}

/**
 * convert list to tree
 * 每次convert都是根据指定根节点查找子节点的过程，将找到的子节点项作为根节点进行递归转换.
 * @param  {Array} list
 * @param  {String} parentKey
 * @param {String} currentKey
 * @param {Any} rootValue
 * @returns {Object}
 */
export function convertListToTree(list, parentKey, currentKey, rootValue) {
  const tree = { id: rootValue };
  let index = 0;
  const leftList = list.slice();
  
  while (index < leftList.length) {
    const item = leftList[index];

    if (item[parentKey] === rootValue && item[currentKey] !== item[parentKey]) {
      // 找到子节点，加入tree
      // 删除该项
      leftList.splice(index, 1);
      const itemTree = {
        ...item,
        ...convertListToTree(leftList, parentKey, currentKey, item[currentKey]),
      };

      if (tree.children) {
        tree.children.push(itemTree);
      } else {
        tree.children = [itemTree];
      }
    } else {
      index += 1;
    }
  }
  return tree;
}

export function getQueryVariable(variable) {
  const { href } = window.location;
  const query = href && href.split('?');
  const vars = query && query[1] && query[1].split('&');
  if (!vars) {
    return null;
  }
  for (let i = 0; i < vars.length; i += 1) {
    const pair = vars[i].split('=');
    if (pair[0] === variable) {
      return pair[1] && decodeURIComponent(pair[1]);
    }
  }
  return null;
}

export function getChild(provinceId, areaTreeData) {
  const array = [];
  areaTreeData.forEach((item) => {
    if (item.value === provinceId) {
      item.children.forEach((each) => {
        array.push(each.value);
      });
    }
  });
  return array;
}

// 将省市混合的数组全都转换为对应的市
export function changeArray(array = [], areaTreeData) {
  let changedArray = [];
  array.forEach((item) => {
    const lastPart = item.substr(2);
    if (lastPart === '0000') {
      const chileren = getChild(item, areaTreeData);
      changedArray = changedArray.concat(chileren);
    } else {
      changedArray.push(item);
    }
  });
  return changedArray;
}

export function generateAuthMenus(authList, routesConfig) {
  const removeUnAuthorizedRoutes = (routesToFormat) => {
    for (let i = routesToFormat.length - 1; i >= 0; i -= 1) {
      const route = routesToFormat[i];
      if (route.authId && !(authList || []).includes(route.authId)) {
        routesToFormat.splice(i, 1);
      }
    }
  };

  const loop = (routes) => {
    for (let i = routes.length - 1; i >= 0; i -= 1) {
      const route = routes[i];
      if (route.routes) {
        removeUnAuthorizedRoutes(route.routes);
        if (route.routes.length > 0) {
          // 如果菜单有权限的子路由个数大于0，则继续递归
          loop(route.routes);
        } else {
          // 如果菜单有权限的子路由个数是0，则需要删除该菜单
          routes.splice(i, 1);
        }
      }
    }
  };

  const routesToLoop = JSON.parse(JSON.stringify(routesConfig));

  removeUnAuthorizedRoutes(routesToLoop);
  loop(routesToLoop);

  return routesToLoop;
}

export function getRouteByPath(pathname, routesConfig) {
  let result;

  const loop = (routes) => {
    for (const r of routes) {
      if (r.path === pathname) {
        result = r;
        break;
      } else if (r.routes && r.routes.length > 0) {
        const s = loop(r.routes);
        if (s) {
          break;
        }
      }
    }
  };

  loop(routesConfig);

  return result;
}

export function getFirstValidRoute(routesConfig) {
  let route = null;
  const getFirstRoute = (currentRoute) => {
    // while遍历routes树，获取第一个可以访问的叶子结点path
    let validRoute = currentRoute;
    while (validRoute && validRoute.routes && validRoute.routes.length > 0) {
      const validRoutes = validRoute.routes;
      if (validRoutes && validRoutes.length > 0) {
        [validRoute] = validRoutes;
      } else {
        validRoute = null;
      }
    }

    return validRoute;
  };

  const loop = (routesToLoop) => {
    for (const r of routesToLoop) {
      route = getFirstRoute(r);
      if (route) {
        break;
      }
    }
  };
  loop(routesConfig);

  return route;
}

export async function goToFirstValidRoute($router, headerMenuPath) {
  const authRoutesConfig = await localforage.getItem(AUTH_ROUTES_CONFIG);

  let routerConfig = authRoutesConfig;
  if (headerMenuPath) {
    routerConfig = authRoutesConfig.filter(r => r.path === headerMenuPath);
  }
  const firstValidRoute = getFirstValidRoute(routerConfig);

  $router.push(firstValidRoute.path);
}
